export const autoShip = {
  autoShip: {
    products: {
      title: 'Auto Shipment Parts Selection',
      tableLabel: 'Auto Shipment Parts Selection',
      navigationLabel: 'Auto Shipment',
      partsSelectionTab: 'Auto Shipment Parts Selection',
      materialNumber: 'Part Number',
      materialDescription: 'Description',
      msrp: 'MSRP',
      netPrice: 'List Price',
      orderQuantity: 'Order Quantity',
      addToCart: 'Add to Cart',
      updateError: 'The Auto Ship cart could not be updated. Please try again.',
      loadError: 'Auto Ship products could not be loaded. Please try again.',
    },
    schedule: {
      title: 'Preferred Shipment Schedule',
      tableLabel: 'Preferred Shipment Schedule',
      navigationLabel: 'Auto Shipment',
      shipmentScheduleTab: 'Preferred Shipment Schedule',
      shipmentsThisYear: 'shipments this calendar year',
      numberOfShipmentsLabel: 'Number of shipments',
      scheduleShipments: 'Schedule Shipments',
      backToProduct: 'Back',
      shipmentSchedule: 'Shipment Schedule',
      scheduleError: 'The Auto Ship shipment schedule could not be saved. Please try again.',
    },
    shipmentDates: {
      title: 'Scheduled Shipments ({{ count }} Total)',
      viewAll: 'View All {{ count }} Shipments',
      showLess: 'Show Less',
    },
  },
};
